import React from 'react';
import './Footer.css';
import { useMediaQuery } from '@mui/material';
import TranslatedText from '../text/TranslatedText';

function Footer() {
  const isAbove1200 = useMediaQuery('(min-width:1200px)');

  return (
    <div className="footer">
      {isAbove1200 && (
      <div>
        ©
        {new Date().getFullYear()}
        {' '}
        <TranslatedText txt="footerDesc" />
      </div>
      )}
      <div className="footer-email">
        {isAbove1200 && (
        <>
          <TranslatedText txt="email" />
          :
        </>
        )}
        {' '}
        jouanny.jerome@gmail.com
      </div>
    </div>
  );
}

export default Footer;
